import { render } from "./ApplicationsOverview.vue?vue&type=template&id=0fc80e74&ts=true"
import script from "./ApplicationsOverview.vue?vue&type=script&lang=ts"
export * from "./ApplicationsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__